// src/config.js
const config = {
  defaultImportPrice: 0.2635,
  defaultExportPrice: 0.15,
  domestic: {
    apr: 0.129,
    term: 10,
    deposit: 0,
  },
  commercial: {
    apr: 0.089,
    term: 7,
    deposit: 0,
  },
  yieldFactor: 900,
  lossFactor: 0.9,
  co2Factor: 0.2,
  co2Scope: "Self + Export",

  pvBands: [
    { label: "2–3 kW", min: 2, max: 3, pricePerW: 2.03 },
    { label: "3–4 kW", min: 3, max: 4, pricePerW: 1.86 },
    { label: "4–5 kW", min: 4, max: 5, pricePerW: 1.74 },
    { label: "5–6 kW", min: 5, max: 6, pricePerW: 1.64 },
    { label: "6–7 kW", min: 6, max: 7, pricePerW: 1.59 },
    { label: "7–8 kW", min: 7, max: 8, pricePerW: 1.53 },
    { label: "8–9 kW", min: 8, max: 9, pricePerW: 1.42 },
    { label: "9–10 kW", min: 9, max: 10, pricePerW: 1.38 },
    { label: "10–12 kW", min: 10, max: 12, pricePerW: 1.33 },
    { label: "12–14 kW", min: 12, max: 14, pricePerW: 1.27 },
    { label: "14–16 kW", min: 14, max: 16, pricePerW: 1.15 },
    { label: "16–18 kW", min: 16, max: 18, pricePerW: 1.05 },
    { label: "18–20 kW", min: 18, max: 20, pricePerW: 1.05 },
    { label: "20–30 kW", min: 20, max: 30, pricePerW: 1.00 },
    { label: "30–40 kW", min: 30, max: 40, pricePerW: 0.95 },
    { label: "40–50 kW", min: 40, max: 50, pricePerW: 0.92 },
    { label: "50–60 kW", min: 50, max: 60, pricePerW: 0.90 },
    { label: "60–70 kW", min: 60, max: 70, pricePerW: 0.88 },
    { label: "70–80 kW", min: 70, max: 80, pricePerW: 0.87 },
    { label: "80–90 kW", min: 80, max: 90, pricePerW: 0.85 },
    { label: "90–100 kW", min: 90, max: 100, pricePerW: 0.83 },
    { label: "100 kW+", min: 100, max: 999999, pricePerW: 0.83 },
  ],


  // Client's New Values
// 2–3 kW = £2.03
// 3–4 kW = £1.86
// 4–5 kW = £1.74
// 5–6 kW = £1.64
// 6–7 kW = £1.59
// 7–8 kW = £1.53
// 8–9 kW = £1.42
// 9–10 kW = £1.38
// 10–12 kW = £1.33
// 12–14 kW = £1.27
// 14–16 kW = £1.15

// 16–18 kW = £1.05
// 18–20 kW = £1.05
// 20–30 kW = £1.00
// 30–40 kW = £0.95
// 40–50 kW = £0.92
// 50–60 kW = £0.90
// 60–70 kW = £0.88
// 70–80 kW = £0.87
// 80–90 kW = £0.85
// 90–100 kW = £0.83
// 100 kW+ = £0.83

  batteries: [
    { name: "5 kWh (Non-intelligent)", brand: "Fox ESS", usable: 5, capture: 0.6, efficiency: 0.9, price: 2500 },
    { name: "10 kWh (Non-intelligent)", brand: "Fox ESS", usable: 10, capture: 0.7, efficiency: 0.9, price: 4500 },
    { name: "5 kWh (Intelligent)", brand: "GivEnergy", usable: 5, capture: 0.85, efficiency: 0.93, price: 3500 },
    { name: "10 kWh (Intelligent)", brand: "GivEnergy", usable: 10, capture: 0.9, efficiency: 0.93, price: 5500 },
    { name: "13.5 kWh (Premium)", brand: "Tesla Powerwall", usable: 13.5, capture: 0.95, efficiency: 0.95, price: 8000 },
    { name: "None", brand: "-", usable: 0, capture: 0, efficiency: 1, price: 0 },
  ],

  evChargers: [
    { option: "Ohme Home Pro", price: 799 },
    { option: "Hypervolt Home 3 Pro", price: 899 },
    { option: "None", price: 0 },
  ],
};

export default config;
